// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_section__dRBtZ {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  border-top: 1px solid #8080801a;
  background-image: linear-gradient(90deg, rgba(99, 102, 241, 0.2), rgba(220, 38, 38, 0.2), rgba(139, 92, 246, 0.2));
  border-image-slice: 1;
  border-image-width: 1;
  border-image-outset: 0;
  border-image-repeat: round; }

.styles_dividerSection__ZHogc {
  width: 100%; }

.styles_contentWrapper__jcA-O {
  max-width: 72rem;
  margin: 0 auto;
  text-align: center; }

.styles_headerSection__dRRtI {
  margin-bottom: 3rem; }

.styles_sectionHeader__5qWPG {
  font-size: 2.5rem;
  font-weight: 400;
  color: #808080e6;
  margin-bottom: 1.5rem;
  text-align: center; }
  @media (min-width: 48rem) {
    .styles_sectionHeader__5qWPG {
      font-size: 3rem; } }

.styles_decorativeDivider__M7bu- {
  width: 4rem;
  height: 0.25rem;
  background-color: #6366f1;
  margin: 0 auto;
  border-radius: 0.125rem; }

.styles_bodySection__G4-G2 {
  max-width: 72rem;
  margin: 3rem auto;
  border-radius: 1.5rem;
  padding: 1rem 1.5rem; }

.styles_bodyText__oQEyk {
  font-size: 1.75rem;
  color: #72ababe6;
  font-weight: 900;
  text-align: center;
  font-style: italic;
  line-height: 1; }
  @media (min-width: 48rem) {
    .styles_bodyText__oQEyk {
      font-size: 1.75rem; } }
`, "",{"version":3,"sources":["webpack://./src/modules/shelter/components/screens/LandingPage/components/DividerSection/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAEA;EAEE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,+BCIgB;EDHhB,kHAAkH;EAClH,qBAAqB;EACrB,qBAAqB;EACrB,sBAAsB;EACtB,0BAA0B,EAAA;;AAG5B;EACE,WAAW,EAAA;;AAIb;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB,EAAA;;AAGpB;EACE,mBAAmB,EAAA;;AAGrB;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gBChBgB;EDiBhB,qBAAqB;EACrB,kBAAkB,EAAA;EAElB;IAPF;MAQI,eAAe,EAAA,EAElB;;AAED;EACE,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,cAAc;EACd,uBAAuB,EAAA;;AAGzB;EACE,gBAAgB;EAChB,iBAAiB;EAEjB,qBAAqB;EACrB,oBAAoB,EAAA;;AAKtB;EACE,kBAAkB;EAClB,gBCvBsB;EDwBtB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,cAAc,EAAA;EAEd;IARF;MASI,kBAAkB,EAAA,EAErB","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.section {\n  // height: 100vh;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-top: 1px solid $grey10;\n  background-image: linear-gradient(90deg, rgba(99, 102, 241, 0.2), rgba(220, 38, 38, 0.2), rgba(139, 92, 246, 0.2));\n  border-image-slice: 1;\n  border-image-width: 1;\n  border-image-outset: 0;\n  border-image-repeat: round;\n}\n\n.dividerSection {\n  width: 100%;\n  // background-color: $grey3;\n}\n\n.contentWrapper {\n  max-width: 72rem;\n  margin: 0 auto;\n  text-align: center;\n}\n\n.headerSection {\n  margin-bottom: 3rem;\n}\n\n.sectionHeader {\n  font-size: 2.5rem;\n  font-weight: 400;\n  color: $grey90;\n  margin-bottom: 1.5rem;\n  text-align: center;\n  \n  @media (min-width: 48rem) {\n    font-size: 3rem;\n  }\n}\n\n.decorativeDivider {\n  width: 4rem;\n  height: 0.25rem;\n  background-color: #6366f1;\n  margin: 0 auto;\n  border-radius: 0.125rem;\n}\n\n.bodySection {\n  max-width: 72rem;\n  margin: 3rem auto;\n  // background: linear-gradient(90deg, rgba(99, 102, 241, 0.18), rgba(220, 38, 38, 0.18), rgba(139, 92, 246, 0.18));\n  border-radius: 1.5rem;\n  padding: 1rem 1.5rem;\n  // border: 0.25rem solid rgba(99, 102, 241, 0.2);\n\n}\n\n.bodyText {\n  font-size: 1.75rem;\n  color:  $ocean_blue90;\n  font-weight: 900;\n  text-align: center;\n  font-style: italic;\n  line-height: 1;\n\n  @media (min-width: 48rem) {\n    font-size: 1.75rem;\n  }\n}\n","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `styles_section__dRBtZ`,
	"dividerSection": `styles_dividerSection__ZHogc`,
	"contentWrapper": `styles_contentWrapper__jcA-O`,
	"headerSection": `styles_headerSection__dRRtI`,
	"sectionHeader": `styles_sectionHeader__5qWPG`,
	"decorativeDivider": `styles_decorativeDivider__M7bu-`,
	"bodySection": `styles_bodySection__G4-G2`,
	"bodyText": `styles_bodyText__oQEyk`
};
export default ___CSS_LOADER_EXPORT___;
